import { useTranslations } from 'next-intl';

import { Text } from '@hrworks/sui-core/Text';

import { Card, CardBody, CardHeader } from '../../Card';
import { ExternalLink } from '../../Link';
import { Title } from '../../Title';
import { S } from './SidebarContact.styles.ts';
import type { SidebarContactProps } from './SidebarContact.types';

// TODO: Remove once profileImage is added to the API schema (HrwPost.contactInformation)
type ContactWithProfile = NonNullable<SidebarContactProps['contactInformation']> & { profileImage?: string };

/** Eigene Kachel unter der Sidebar-Card, Header wie "Das Unternehmen" (panelStyle des Kunden). */
export const SidebarContact = ({ contactInformation, ...otherProps }: SidebarContactProps) => {
  const t = useTranslations('Job');

  if (!contactInformation) {
    return;
  }

  const { contactPerson, phone, email, profileImage } = contactInformation as ContactWithProfile;
  const fullName = contactPerson ? `${contactPerson.firstName} ${contactPerson.lastName}` : undefined;

  return (
    <Card data-guide-id="sidebar-contact" {...otherProps}>
      <CardHeader variant="panel">
        <Title>{t('contact')}</Title>
      </CardHeader>
      <CardBody>
        <S.Content>
          {profileImage && <S.Image data-guide-id="sidebar-contact-image" alt={fullName ?? ''} src={profileImage} />}
          <div>
            {fullName && (
              <Text data-guide-id="sidebar-contact-name" overflowBehaviour="break" title={fullName}>
                {fullName}
              </Text>
            )}
            {phone && (
              <div>
                <ExternalLink href={`tel:${phone}`}>
                  <Text overflowBehaviour="break" title={phone}>
                    {phone}
                  </Text>
                </ExternalLink>
              </div>
            )}
            {email && (
              <div>
                <ExternalLink href={`mailto:${email}`}>
                  <Text title={email} overflowBehaviour="break">
                    {email}
                  </Text>
                </ExternalLink>
              </div>
            )}
          </div>
        </S.Content>
      </CardBody>
    </Card>
  );
};
